__webpack_require__.p = "/notifications-infinite-scroll/referrals-hub/";